var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgImageIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "m15 3 1.85 2H20q.824 0 1.413.588Q22 6.175 22 7v12q0 .824-.587 1.413A1.93 1.93 0 0 1 20 21H4q-.824 0-1.413-.587A1.93 1.93 0 0 1 2 19V7q0-.824.587-1.412A1.93 1.93 0 0 1 4 5h3.15L9 3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D3F4FF",
  d: "m14.125 5 1.825 2H20v12H4V7h4.05l1.825-2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "M12 8.5q1.875 0 3.188 1.313Q16.5 11.125 16.5 13t-1.313 3.188Q13.875 17.5 12 17.5t-3.188-1.313Q7.502 14.876 7.5 13q0-1.875 1.313-3.188Q10.125 8.5 12 8.5"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D3F4FF",
  d: "M12 10.5q-1.05 0-1.775.725T9.5 13c0 1.05.242 1.292.725 1.775q.725.725 1.775.725c1.05 0 1.292-.242 1.775-.725Q14.5 14.05 14.5 13c0-1.05-.242-1.292-.725-1.775Q13.05 10.5 12 10.5"
}))));
export default SvgImageIcon;